import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('@/pages/home/page'));
const AboutPage = lazy(() => import('@/pages/about/page'));
const ContractorsPage = lazy(() => import('@/pages/contractors/page'));
const ContactPage = lazy(() => import('@/pages/contact/page'));
const MajorProjectsPage = lazy(() => import('@/pages/major-projects/page'));
const ResourcesPage = lazy(() => import('@/pages/resources/page'));
const AlliancePage = lazy(() => import('@/pages/alliance/page'));
const BlogPage = lazy(() => import('@/pages/blog/page'));
const NotFound = lazy(() => import('@/pages/NotFound'));

const PerformanceBondsPost = lazy(() => import('@/pages/blog/posts/performance-bonds-pa-contractors'));
const GeneralLiabilityPost = lazy(() => import('@/pages/blog/posts/general-liability-contractors-bucks-county'));
const RiskManagementPost = lazy(() => import('@/pages/blog/posts/risk-management-montgomery-county'));
const UnionBondsPost = lazy(() => import('@/pages/blog/posts/union-bonds-pa-contractors'));
const WorkersCompPost = lazy(() => import('@/pages/blog/posts/workers-comp-pa-contractors'));
const PharmacyInsurancePost = lazy(() => import('@/pages/blog/posts/pharmacy-insurance-pennsylvania'));
const MedicalPracticePost = lazy(() => import('@/pages/blog/posts/medical-practice-insurance-pennsylvania'));
const RetailInsurancePost = lazy(() => import('@/pages/blog/posts/retail-business-insurance-pennsylvania'));
const BuildersRiskPost = lazy(() => import('@/pages/blog/posts/builders-risk-insurance-pennsylvania'));
const ContractorBondPost = lazy(() => import('@/pages/blog/posts/license-permit-bonds-pennsylvania'));
const CommercialAutoPost = lazy(() => import('@/pages/blog/posts/commercial-auto-insurance-pa-contractors'));
const UmbrellaInsurancePost = lazy(() => import('@/pages/blog/posts/umbrella-insurance-pa-contractors'));

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/contractors', element: <ContractorsPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '/major-projects', element: <MajorProjectsPage /> },
  { path: '/resources', element: <ResourcesPage /> },
  { path: '/alliance', element: <AlliancePage /> },
  { path: '/blog', element: <BlogPage /> },
  { path: '/blog/performance-bonds-pa-contractors', element: <PerformanceBondsPost /> },
  { path: '/blog/general-liability-contractors-bucks-county', element: <GeneralLiabilityPost /> },
  { path: '/blog/risk-management-montgomery-county', element: <RiskManagementPost /> },
  { path: '/blog/union-bonds-pa-contractors', element: <UnionBondsPost /> },
  { path: '/blog/workers-comp-pa-contractors', element: <WorkersCompPost /> },
  { path: '/blog/pharmacy-insurance-pennsylvania', element: <PharmacyInsurancePost /> },
  { path: '/blog/medical-practice-insurance-pennsylvania', element: <MedicalPracticePost /> },
  { path: '/blog/retail-business-insurance-pennsylvania', element: <RetailInsurancePost /> },
  { path: '/blog/builders-risk-insurance-pennsylvania', element: <BuildersRiskPost /> },
  { path: '/blog/license-permit-bonds-pennsylvania', element: <ContractorBondPost /> },
  { path: '/blog/commercial-auto-insurance-pa-contractors', element: <CommercialAutoPost /> },
  { path: '/blog/umbrella-insurance-pa-contractors', element: <UmbrellaInsurancePost /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
